import type { FC, ReactNode } from 'react'

import { SearchX } from 'lucide-react'
import { cn } from '@/lib/utils'

interface EmptyStateProps {
    title: string
    text?: ReactNode
    action?: ReactNode
    className?: string
}

const EmptyState: FC<EmptyStateProps> = ({ title, text, action, className }): ReactNode => {
    return (
        <div className={cn('flex flex-col items-center gap-3 rounded-xl border-2 border-dashed border-foreground bg-card px-6 py-12 text-center', className)}>
            <span className='flex size-12 items-center justify-center rounded-lg border-2 border-foreground bg-primary'>
                <SearchX className='size-6' aria-hidden='true' />
            </span>

            <h3 className='text-lg font-bold'>
                {title}
            </h3>

            {text && (
                <p className='max-w-md text-sm leading-relaxed text-muted-foreground'>
                    {text}
                </p>
            )}

            {action}
        </div>
    )
}

export default EmptyState
